import { Container, Row, Col } from "react-bootstrap";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Trans, useTranslation } from 'react-i18next';

import { useState, useEffect } from 'react';

import useSignIn from "react-auth-kit/hooks/useSignIn";
import useSignOut from "react-auth-kit/hooks/useSignOut";
import useIsAuthenticated from "react-auth-kit/hooks/useIsAuthenticated";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import useAuthHeader from "react-auth-kit/hooks/useAuthHeader";

import Login from '../components/Login';
import Register from '../components/Register';
import ForgotPassword from '../components/ForgotPassword';
import ResetPassword from "../components/ResetPassword";
import Success from '../components/Success';

const BACKENDURL = window.reactInit.backendurl+'/user';

// TODO.
// confirm error handling (ie. past expiry, etc.)

export default function Account(){
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const path = location.pathname.split('/')[1];
    const { hash } = useParams();
    const navigate = useNavigate();

    const signIn = useSignIn();
    const logout = useSignOut();
    const isAuthenticated = useIsAuthenticated();
    const auth = useAuthUser();
    const token = useAuthHeader();


    const [ state, setState ] = useState(path);
    const [ error, setError ] = useState({});

    const handleLogin = (e,p) => {
        console.log('login',e);
        fetch(BACKENDURL+'/login',{method:'POST',body:new URLSearchParams({email:e,password:p})})
            .then( resp => resp.json() )
            .then( resp => {
                console.log('login result');
                console.log(resp);
                if (resp.status) {
                    setError(resp);
                } else if (resp.token) {
                    const { token, ...userData } = resp;
                    console.log('login',token,userData);

                    const logged = signIn({
                        auth: {
                          token: token
                        },
                        userState: userData
                      });
                    if (logged) {
                        // If Login Successfull, then Redirect the user to secure route
                        if (userData.submitted) {
                            navigate('/success');
                        } else {
                            navigate('/application');
                        }
                    } else {
                        console.log('not logged in');
                        // Else, there must be some error. So, throw an error
                        setError({status:500});
                    }
                }
            } )
            .catch( err => setError(err) );
    }
    const handleRegister = (fn,ln,e,p,o,tr,c,pr,w,c1,c2,t) => {
        console.log('register',fn,ln,e,p,o,tr,c,pr,w,c1,c2,t);
        fetch(BACKENDURL+'/signup',{method:'POST',body:new URLSearchParams({
            fname:fn,
            lname:ln,
            email:e,
            password:p,
            organization:o,
            titlerole:tr,
            city:c,
            province:pr,
            website:w,
            consent1:c1,
            consent2:c2,
            token:t,
            lang:i18n.resolvedLanguage})})
            .then( resp => resp.json() )
            .then( resp => {
                
                if (resp.success) {
                    setState('success-register');
                } else {
                    console.log('set error',resp.status);
                    setError(resp);
                }
            } )
            .catch( err => setError(err) );
    };
    const handleForgotPassword = (e) => {
        console.log('forgot',e);
        fetch(BACKENDURL+'/passwordrecover',{method:'POST',body:new URLSearchParams({
            email:e,
            lang: i18n.resolvedLanguage})})
            .then( resp => resp.json() )
            .then( resp => {
                
                if (resp.success) {
                    setState('success-forgotpassword');
                } else {
                    console.log('set error',resp.status);
                    setError(resp);
                }
            } )
            .catch( err => setError(err) );
    }
    const handleResetPassword = (p) => {
        console.log('reset',p);
        const params = {
            email: auth.email,
            password: p
        }
        fetch(BACKENDURL+'/passwordreset',{ method:'POST',
            body:new URLSearchParams(params),
            headers:{'Authorization':token} } )
        .then( resp => resp.json() )
        .then( resp => {
            
            if (resp.success) {
                // continue. 
                // auth["q"+e] = answers[e];
                navigate('/login');
            } else {
                // console.log('set error',resp.status);
                setError(resp);
            }
        } )
        .catch( err => setError(err) );
    }
    const checkHash = (_hash) => {
        console.log('check',_hash);
        fetch(BACKENDURL+'/checkhash',{method:'POST',body:new URLSearchParams({hash:_hash})})
            .then( resp => resp.json() )
            .then( resp => {
                console.log(resp);
                if (resp.status) {
                    console.log('set error',resp.status);
                    setError(resp);
                } else {

                    // set token. // confirmation.
                    const { token, ...userData } = resp;
                    console.log('login',token,userData);
                    const logged = signIn({
                        auth: {
                          token: token
                        },
                        userState: userData
                    }); // loophole. if user is resetting password, if they navigate away from this page, they are still technically logged in.
                    

                    if (logged) {
                        // do nothing. renderSwitch will take care of displaying the right thing here.
                        if (path==='confirm'){
                            // If Login Successfull, then Redirect the user to secure route
                            // setState('reset-form');
                        } else {
                            // render forgot password form.
                            // setState('reset-form');
                        }
                        setError({status:0});
                    } else {
                        // Else, there must be some error. So, throw an error
                        setError({status:500});
                    }
                }
            })
            .catch( err => setError(err) );
    }
    const handleLogout = () => {
        logout();
        navigate('/login');
    }

    const handleErrorClick = () => {
        console.log('error click',error.status);
        if (error.status===405 && state==='confirm') {
            fetch(BACKENDURL+'/reconfirm',{method:'POST',body:new URLSearchParams({hash,lang:i18n.resolvedLanguage})})
            .then( resp => resp.json() )
            .then( resp => {
                
                if (resp.success) {
                    setState('success-register');
                } else {
                    console.log('set error',resp.status);
                    setError(resp);
                }
            } )
            .catch( err => setError(err) );
        } else if (error.status===405 && state==='reset') {
            fetch(BACKENDURL+'/passwordrecover',{method:'POST',body:new URLSearchParams({hash,lang:i18n.resolvedLanguage})})
            .then( resp => resp.json() )
            .then( resp => {
                
                if (resp.success) {
                    setState('success-forgotpassword');
                } else {
                    console.log('set error',resp.status);
                    setError(resp);
                }
            } )
            .catch( err => setError(err) );
        }
    }

    useEffect(()=>{
        const thispath = location.pathname.split('/')[1];
        if (state!==thispath) {
            // console.log('nav');
            setError({}); // clear out any existing errors.
            setState(thispath);
        }
    },[location.pathname])

    useEffect(()=>{
        if (state==='confirm'||state==='reset'){
            checkHash(hash);
        }
    },[state]);

    const renderSwitch = () => {
        if (isAuthenticated) {
            switch(state) {
                case 'reset':
                    return <ResetPassword 
                        user={auth}
                        onSubmit={handleResetPassword}
                        errorState={error} />; 
                default:
                    return <>
                            <p className="text-center">
                                <Link to="/application" className="button">{t('confirm.cta')}</Link>
                            </p>
                            <p className="text-center">{t('confirm.body')}</p>
                            <p className="text-center">
                                <button onClick={handleLogout}>{t('login.signout')}</button>
                            </p>
                    </>;
            }
        } else {
            switch(state) {
                case 'login':
                    return <Login onSubmit={handleLogin} 
                    handleRegister={()=>navigate('/register')} 
                    handleRecover={()=>navigate('/recover')}
                    errorState={error} />;
                case 'register':
                    return <Register onSubmit={handleRegister}
                        handleLogin={()=>navigate('/login')} errorState={error} />;
                case 'recover':
                    return <ForgotPassword onSubmit={handleForgotPassword}
                    handleRegister={()=>navigate('/register')} errorState={error} />;
                case 'confirm':
                case 'reset':
                    return <p>
                        <Trans i18nKey={'errors.'+error.status} components={[<span onClick={handleErrorClick} className="text-link" />]} />
                        </p>;
                case 'success-register':
                case 'success-forgotpassword':
                    return <Success state={state} />
            }
        }
    }

    return (
        <Container fluid as="main" className="account">
            <Row className="skinny-row">
                <Col>
                    {isAuthenticated && path!=='confirm'
                        ? <h2 className="text-sm-center">{t('return.title')}</h2>
                        : <h2 className="text-sm-center">{t(path+'.title')}</h2> }
                </Col>
            </Row>
            <Row className="skinny-row">
                <Col className="form-col py-5 px-3 px-sm-10">
                    {renderSwitch()}
                </Col>
            </Row>
        </Container>
    );
}